<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align:center"><span><img alt="title" src="images/part-1.jpg"/></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Part01.vue?7def94a6